export const log = [
  { title: "Delta Air Lines Simplifies Fare Structure with Rebrand",
    date: "2025-05-15",
    source: "Investopedia",
    url: "https://www.investopedia.com/delta-air-lines-announces-rebrand-of-ticket-tiers-heres-why-11735609",
    company: "Delta Air Lines",
    industry: "Aviation",
    region: "Global",
    type: "Service Tier Rebrand",
    summary: "Delta Air Lines has rebranded its ticket fare structure to provide clearer distinctions and more customization options for travelers, effective October 1, 2025.",
    key_points: [
      "Main Cabin becomes 'Delta Main'; Comfort+ is now 'Delta Comfort'; First Class is 'Delta First'.",
      "Introduction of 'classic' and 'extra' options within each tier, replacing fully refundable tickets.",
      "Delta Main category adds 'Delta Main Basic', replacing the current basic economy offering."
    ],
    notes: "This rebranding aims to enhance customer experience through clearer tier distinctions and customizable options, potentially supporting upselling by emphasizing differences in services such as boarding and upgrade priority.",
    platforms_affected: ["Booking Systems", "Mobile App", "Website"],
    visual_assets: [],
    tone_of_voice_change: "From traditional to more transparent and flexible",
    design_agency: null,
    audience_targeted: ["Business Travelers", "Leisure Travelers"],
    launch_campaign_name: null,
    suggested_hashtags: ["#DeltaRebrand", "#TravelSimplified", "#FlyDelta"],
    caption: "✈️ Delta Air Lines revamps its fare structure for clarity and flexibility. Discover the new 'Delta Main', 'Delta Comfort', and 'Delta First' tiers launching this October."
  },
  { title: "Airbnb Embraces Local Flavor with 'Icons' Experience Launch",
    date: "2024-04-30",
    source: "TechCrunch",
    url: "https://techcrunch.com/2024/04/30/airbnb-icons-experiences-launch/",
    company: "Airbnb",
    industry: "Hospitality",
    region: "Global",
    type: "Brand Extension",
    summary: "Airbnb has launched a new initiative called 'Icons' — a curated set of exclusive experiences with celebrities and cultural landmarks, shifting the brand from lodging to lifestyle.",
    key_points: [
      "'Icons' includes immersive experiences like cooking with famous chefs or staying in iconic pop culture locations.",
      "Airbnb positions itself as a curator of unforgettable experiences, expanding its value proposition beyond housing.",
      "Launch comes as travel rebounds post-COVID, and consumers seek more meaningful, story-driven vacations."
    ],
    notes: "This move allows Airbnb to lean deeper into culture and storytelling, reinforcing its identity as a platform for personal connection and emotional resonance.",
    platforms_affected: ["Mobile App", "Website", "Social Media"],
    visual_assets: [],
    tone_of_voice_change: "From utility to cultural curator",
    design_agency: null,
    audience_targeted: ["Experience Seekers", "Gen Z & Millennials", "Culture Enthusiasts"],
    launch_campaign_name: "Airbnb Icons",
    suggested_hashtags: ["#AirbnbIcons", "#LiveThere", "#BrandExtension"],
    caption: "🌍 Airbnb isn't just where you stay — it's what you *live*. Introducing 'Icons': cultural experiences that turn your trip into a story worth telling."
  },
  { title: "Warner Bros. Discovery Reverts 'Max' Back to 'HBO Max'",
    date: "2025-05-15",
    source: "Business Insider",
    url: "https://www.businessinsider.com/hbo-max-rebrands-again-why-warner-bros-discovery-is-reversing-course-2025-5",
    company: "Warner Bros. Discovery",
    industry: "Streaming Media",
    region: "Global",
    type: "Brand Reversion",
    summary: "Warner Bros. Discovery is rebranding its streaming service back to 'HBO Max', acknowledging the strength and recognition of the HBO brand.",
    key_points: [
      "The 'Max' brand, introduced in 2023, led to confusion and diluted HBO's premium image.",
      "Reversion aims to leverage HBO's strong brand equity and focus on high-quality content.",
      "The move reflects a strategic pivot towards emphasizing quality over broad content aggregation."
    ],
    notes: "This rebranding underscores the importance of brand equity and the risks of diluting a well-established brand identity in pursuit of broader appeal.",
    platforms_affected: ["Streaming Service", "Marketing Materials", "User Interface"],
    visual_assets: [],
    tone_of_voice_change: "Refocusing on premium and sophisticated content",
    design_agency: null,
    audience_targeted: ["Adult Viewers", "Premium Content Subscribers"],
    launch_campaign_name: null,
    suggested_hashtags: ["#HBOMax", "#StreamingNews", "#BrandStrategy"],
    caption: "🎬 HBO is back! Warner Bros. Discovery reverts 'Max' to 'HBO Max', reaffirming its commitment to premium content. A strategic move to strengthen brand identity."
  },
  { title: "Pepsi Unveils Bold New Logo After 14 Years",
    date: "2023-03-28",
    source: "Ad Age",
    url: "https://adage.com/article/marketing-news-strategy/pepsi-unveils-new-logo-first-time-14-years/2477521",
    company: "Pepsi",
    industry: "Beverages",
    region: "Global",
    type: "Visual Identity Refresh",
    summary: "Pepsi has introduced a new visual identity — its first major redesign since 2008 — featuring a bold typeface, electric blue, and a nod to its classic 90s look.",
    key_points: [
      "The new logo centers the word 'Pepsi' inside the globe again — a throwback to its 90s era.",
      "Design reflects a more digital-forward presence, optimized for screens, packaging, and social media.",
      "Color palette shifts to black and electric blue, supporting the brand’s zero sugar push and youthful energy."
    ],
    notes: "Pepsi’s move emphasizes nostalgia with modern clarity — capturing Gen Z and Millennials who resonate with throwback aesthetics while keeping the visual crisp for digital platforms.",
    platforms_affected: ["Packaging", "Social Media", "Digital Screens", "Merchandise"],
    visual_assets: [],
    tone_of_voice_change: "From playful to bold and confident",
    design_agency: "PepsiCo Design and Innovation Team",
    audience_targeted: ["Gen Z", "Millennials", "Soft Drink Consumers"],
    launch_campaign_name: null,
    suggested_hashtags: ["#PepsiRebrand", "#BoldTaste", "#NewLook"],
    caption: "🥤 After 14 years, Pepsi gets a makeover. The new look is bold, digital-first, and rooted in nostalgia. Welcome to Pepsi’s electric era."
  }
];
